<script lang="ts">
    /**
 *
 *
 *
 *
 */
    import DynamicEsi from '@shared/components/dynamic-esi/DynamicEsi.svelte';
    import { footerAttributes } from '@tilelist/domain/external-data-attributes/ExternalDataAttributes.ts';

    interface Props {
        dreson: string;
    }

    let { dreson }: Props = $props();

    const src = $derived(`/benefit-cinema/teaser/productlist/assets?dreson=${encodeURIComponent(dreson)}`);
</script>

<div class="reptile-benefit-teaser" {...footerAttributes}>
    <DynamicEsi {src} name="BenefitTeaser" />
</div>

<style lang="scss">
    .reptile-benefit-teaser {
        width: 100%;
    }
</style>
